// dependencies
import * as Sentry from "@sentry/react";
import { CreateProcess } from "redux-process";

// utils

export const getTeamsConfig = CreateProcess({
	method: "GET",
	name: "getTeamsConfig",
	type: "MSTEAMS:GET_TEAMS_CONFIG",

	request: () => ({
		url: "/api/microsoft_teams/config/?",
	}),

	success: (response) => {
		try {
			return response.data;
		} catch (ermahgerd) {
			Sentry.captureException(ermahgerd);
			return [];
		}
	},
});

export const getTeamsList = CreateProcess({
	method: "GET",
	name: "getTeamsList",
	type: "MSTEAMS:GET_ALL_TEAMS",

	request: () => ({
		url: "/api/microsoft_teams/fetch-teams-on-tenant/?",
	}),

	success: (response) => {
		try {
			return response.data;
		} catch (ermahgerd) {
			Sentry.captureException(ermahgerd);
			return [];
		}
	},
});

export const getTeamsMetadata = CreateProcess({
	method: "GET",
	name: "getTeamsMetadata",
	type: "MSTEAMS:GET_TEAMS_METADATA",

	request: () => ({
		url: "/api/microsoft_teams/metadata/?",
	}),

	success: (response) => {
		try {
			return response.data;
		} catch (ermahgerd) {
			Sentry.captureException(ermahgerd);
			return [];
		}
	},
});

export const getTeamsInstallStatus = CreateProcess({
	method: "POST",
	name: "getTeamsInstallStatus",
	type: "MSTEAMS:GET_TEAMS_INSTALL_STATUS",

	request: (props) => {
		const { params } = props;
		return {
			url: "/api/microsoft_teams/is-app-intalled-on-team/?",
			payload: params,
		};
	},

	success: (response) => {
		try {
			return response.data;
		} catch (ermahgerd) {
			Sentry.captureException(ermahgerd);
			return [];
		}
	},
});

export const getChannelsOnTeam = CreateProcess({
	method: "GET",
	name: "getChannelsOnTeam",
	type: "MSTEAMS:GET_CHANNELS_ON_TEAM",

	request: (props) => {
		const { params } = props;
		const { teamID } = params;
		return {
			url: `/api/microsoft_teams/get-channels-on-team/${teamID}/?`,
		};
	},

	success: (response) => {
		try {
			return response.data;
		} catch (ermahgerd) {
			Sentry.captureException(ermahgerd);
			return [];
		}
	},
});

export const installApp = CreateProcess({
	method: "POST",
	name: "installApp",
	type: "MSTEAMS:INSTALL_TEAMS",

	request: (props) => {
		const { params } = props;

		return {
			url: "/api/microsoft_teams/install/",
			payload: params,
		};
	},

	success: (response) => {
		try {
			return response.data;
		} catch (ermahgerd) {
			Sentry.captureException(ermahgerd);
			return [];
		}
	},
});

export const updateTeamsSettings = CreateProcess({
	method: "POST",
	name: "updateTeamsSettings",
	type: "MSTEAMS:UPDATE_TEAMS_SETTINGS",

	request: (props) => {
		const { params } = props;

		return {
			url: "/api/microsoft_teams/config/",
			payload: params,
		};
	},

	success: (response) => {
		try {
			return response.data;
		} catch (ermahgerd) {
			Sentry.captureException(ermahgerd);
			return [];
		}
	},
});
